import {RootState} from "@/store";
import {ActionTree} from "vuex";
import {DatapointsState} from "@/store/modules/datapoints";

export const actions: ActionTree<DatapointsState, RootState> = {

}
